import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { AccidentesTabForm } from './accidentes-tab-form';




export const AccidentesTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);

    const handleNewAction = () => {
        open('common.form-title.new', <AccidentesTabForm exp={item} close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            newActionTitle={'common.form-title.new'}
        >
            <Table
                path={`/fleet/accidents/`}
                query={`driver=${item?.id}`}
                deletePath={`/fleet/accidents/`}
                callBeforeDrawerClosed={handleClose}
                Form={AccidentesTabForm}
                withPagination
                refresh={refresh}
                headers={[
                    {
                        key: 'date',
                        type: 'datetime',
                        label: 'common.label.fecha-hora',
                    }, 
                    {
                        key: 'location',
                        label: 'common.label.ubicacion',
                    },
                    {
                        key: 'description',
                        label: 'common.form-label.descripcion',
                    },
              /*       {
                        key: 'status',
                        type: 'status',
                        label: 'common.label.estado',
                    }, */
                ]}
            />
        </PageBody>
    );
};